import {
  AccessControl,
  ICPlatformVersion,
  WarehouseLocationFeature,
} from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'

/**
 * Partner-scoped "Device accounts" (multi-banner) route. Repeats every gate of the legacy
 * `partnerPickDevicesAccessControl` and adds the release-train gate, so the preview entry
 * appears on r2026_11_0+ (internal accounts skip min-version checks and see the Preview badge).
 */
export const partnerPickDevicesPartnerScopedAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.PartnerPickDevicesManageShoppers,
    warehouseLocationFeatures: AccessControl.oneOf([
      WarehouseLocationFeature.RetailerPickup,
      WarehouseLocationFeature.RetailerAlcoholDelivery,
    ]),
    notFeatureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
    minICPlatformVersion: ICPlatformVersion.r2026_11_0,
  },
  {
    permissions: Permission.PartnerPickDevicesManageShoppers,
    warehouseLocationFeatures: AccessControl.oneOf([
      WarehouseLocationFeature.RetailerPickup,
      WarehouseLocationFeature.RetailerAlcoholDelivery,
    ]),
    notFeatureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
    minICPlatformVersion: ICPlatformVersion.r2026_11_0,
  },
  {
    permissions: Permission.PartnerPickDevicesManageShoppers,
    featureEntitlementIds: [FeatureEntitlements.ScanAndPayRetailers],
    notFeatureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
    minICPlatformVersion: ICPlatformVersion.r2026_11_0,
  },
]

/**
 * Access control for the LEGACY nav entry only (never the route). Pairs with the
 * partner-scoped preview entry above: external users flip legacy → preview at r2026_11_0,
 * while the legacy route itself keeps the ungated `partnerPickDevicesAccessControl`.
 */
export const partnerPickDevicesLegacyNavAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.PartnerPickDevicesManageShoppers,
    warehouseLocationFeatures: AccessControl.oneOf([
      WarehouseLocationFeature.RetailerPickup,
      WarehouseLocationFeature.RetailerAlcoholDelivery,
    ]),
    notFeatureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
    maxICPlatformVersionExclusive: ICPlatformVersion.r2026_11_0,
  },
  {
    permissions: Permission.PartnerPickDevicesManageShoppers,
    warehouseLocationFeatures: AccessControl.oneOf([
      WarehouseLocationFeature.RetailerPickup,
      WarehouseLocationFeature.RetailerAlcoholDelivery,
    ]),
    notFeatureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
    maxICPlatformVersionExclusive: ICPlatformVersion.r2026_11_0,
  },
  {
    permissions: Permission.PartnerPickDevicesManageShoppers,
    featureEntitlementIds: [FeatureEntitlements.ScanAndPayRetailers],
    notFeatureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
    maxICPlatformVersionExclusive: ICPlatformVersion.r2026_11_0,
  },
]
